import React from "react";
import {
  ButtonEdit,
  ButtonDelete,
  EditElementClick,
} from "../../common/Buttons";
import { GoPrimitiveDot } from "react-icons/go";

function TableColumnRivileService({ id, item, onDelete, index, onAction }) {
  const assignments = item.document_assignments || [];

  return (
    <tr className="align-middle tableColumn" key={index}>
      <td className="align-middle">
        <GoPrimitiveDot
          className={`${item.has_vat ? "text-success" : "text-danger"}`}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", index)}
          name={item.id_product}
        />
      </td>
      <td className="align-middle">
        {item.order_shops
          .sort((a, b) => (a.id > b.id ? 1 : -1))
          .map((e) => (
            <div className="flex align-items-center">
              <GoPrimitiveDot className={"text-success"} />
              <span>{e.identifier}</span>
            </div>
          ))}
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", index)}
          name={item.title}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", index)}
          name={item.rivile_code}
        />
      </td>
      <td className="align-middle">
        {assignments.length === 0 ? (
          <span className="text-muted">-</span>
        ) : (
          assignments.map((assignment) => (
            <div key={assignment.plan_id}>
              {assignment.order_shop_identifier && (
                <span className="text-muted mr-1">
                  {assignment.order_shop_identifier}
                </span>
              )}
              <span>{assignment.document_type_name}</span>
            </div>
          ))
        )}
      </td>
      <td className="align-middle">
        {assignments.length === 0 ? (
          <span className="text-muted">-</span>
        ) : (
          assignments.map((assignment) => (
            <div
              key={assignment.plan_id}
              className="d-flex align-items-center"
              title={`${assignment.percentage}% + ${assignment.cost} €`}
            >
              <GoPrimitiveDot
                className={assignment.active ? "text-success" : "text-danger"}
              />
              <span>{assignment.plan_name}</span>
            </div>
          ))
        )}
      </td>
      <td>{item.alt_price}</td>
      <td>{item.alt_code}</td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonEdit onEdit={() => onAction("edit", index)} />
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonDelete onDelete={() => onDelete(id)} />
      </td>
    </tr>
  );
}

export default TableColumnRivileService;
